// Usage Limits Configuration
// ==========================
// Central configuration for all usage limits in the application.
// Used by Firebase services to enforce cost management boundaries.

export const LIMITS = {
  // Maximum number of active learning journeys per user
  MAX_ACTIVE_JOURNEYS: 5,

  // Maximum number of uploaded materials (files) per journey
  MAX_MATERIALS_PER_JOURNEY: 10,
} as const;
